import * as Sentry from '@sentry/angular-ivy';

export interface SentryErrorContext {
  message: string;
  context: string; // e.g., "ApprovalsEffects"
  feature: string; // e.g., "LoadFilterUsers"
  extra?: Record<string, any>; // Additional data
  tags?: Record<string, string>; // Custom tags
}

export function reportErrorToSentry(error: any, context: SentryErrorContext): void {

    Sentry.withScope(scope => {
        scope.setTag('frontErrorContext', context.context);
        scope.setTag('frontErrorFeature', context.feature);
        if (context.tags) {
          Object.entries(context.tags).forEach(([key, value]) => scope.setTag(key, value));
        }
        scope.setExtras({
          ...(context.extra || {}),
          customMessage: context.message // Move message to extras
        });
        // Sentry.captureException(error);

        Sentry.captureMessage(context.message, 'error'); // Log as error level
      });
}

export interface SentryActionErrorContext {
    actionName: string; // e.g., "[Approvals] Load Filter Users" the action type string that caused the error
    message?: string;
    extra?: Record<string, any>;
    tags?: Record<string, string>;
}
/**
 * 
 * @param error the exception error captured in the store
 * @param context The context of the action that caused the error
 */
export function reportActionErrorToSentry(error: any, context: SentryActionErrorContext): void {
    // Rename the error to match the action
    const actionError = error instanceof Error ? error : new Error(String(error));
    actionError.name = `Error: ${context.actionName}`;

    Sentry.withScope(scope => {
        scope.setTag('frontErrorContext', context.actionName); // Action name as context
        if (context.tags) {
            Object.entries(context.tags).forEach(([key, value]) => scope.setTag(key, value));
        }
        scope.setExtras({
            ...(context.extra || {}),
            customMessage: context.message
        });
        Sentry.captureException(actionError);
    });
}



